import { Extension } from '@tiptap/core';
import { EXTENSION_TYPE_NAME } from './constants';
import { PapiDeviation } from '@wix/da-papi-types';

export interface DaMuroOptions {}

export interface DaMuroAttrs {}

// Muro is opened from its button
declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    muro: {
      daMuroUseDrawing: (deviation: PapiDeviation) => ReturnType;
    };
  }
}

export const DaMuro = Extension.create<DaMuroOptions>({
  name: EXTENSION_TYPE_NAME,

  addCommands() {
    return {
      daMuroUseDrawing:
        (deviation: PapiDeviation) =>
        ({ editor, chain, dispatch, tr, commands, state }) => {
          if (dispatch) {
            return chain().daDeviationAddDeviation(deviation).run();
          }
          return true;
        },
    };
  },
});
